<template>
  <div
    class="d-flex flex-row align-items-center justify-content-end w-100"
    style="cursor:pointer;"
  >
    <div
      class="d-flex flex-row align-items-center text-primary"
      style="font-weight:bold;"
      @click="$emit('editDocument')"
    >
      <p class="m-0 p-0 mr-2">
        {{ option }}
      </p>

      <!-- <b-icon class="m-0 p-0 h4" :icon="icon" :variant="variant" /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "FormButton",
  props: {
    status: {
      type: String,
      required: false
    },
    readOnly: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    // statusTreat() {
    //   return this.status.toLowerCase();
    // },
    option() {
      // if (this.statusTreat != "completed" && this.readOnly)
      //   return "View (ReadOnly)";
      if (this.readOnly) return "View";
      return this.statusTreat === "completed" ? "View" : "Start";
    },
    icon() {
      if (this.statusTreat != "completed" && this.readOnly) return "eye-fill";
      return this.statusTreat === "completed" ? "eye-fill" : "play-circle-fill";
    },
    variant() {
      if (this.statusTreat != "completed" && this.readOnly) return "danger";
      return this.statusTreat === "completed" ? "success" : "warning";
    }
  }
};
</script>

<style lang="scss"></style>
